module.exports = __webpack_public_path__ + "img/middle.6e53cf0e.png";